import React from 'react';
import Banner from '../../components/Banner/banner';
import VideoFacade from '../../components/VideoFacade/VideoFacade';
import SEO from '../../components/SEO/SEO';
import imgBanner from '../../assets/img/slider-pagina-actriz2.png';
import writerImage from '../../assets/book/Laura-Candela-11.jpg';
import cvPdf from '../../assets/cv/Laura-Candela-CV.pdf';
import { useTranslation } from 'react-i18next';
import './actress.scss';

const Actress = () => {
  const [t] = useTranslation('global');

  const sceneClips = [
    { src: 'https://www.youtube.com/embed/qt_syihgwyc', title: 'Scene Clip 1' },
    { src: 'https://www.youtube.com/embed/lJ1hgas_NX4', title: 'Scene Clip 2' },
    { src: 'https://www.youtube.com/embed/HZmT-ysYBTA', title: 'Scene Clip 3' },
    { src: 'https://www.youtube.com/embed/jQ1gWwqx0Hc', title: 'Scene Clip 4' }
  ];

  return (
    <main className="globalContainer">
      <SEO title={t('Nav.Actress')} canonicalPath="/actress" />

      <Banner name={imgBanner} alt="Laura Candela Acting" />

      <section className="globalSection" aria-label="Acting Showreels and Scenes">
        <h1 className="sectionTitle">{t('ActressTitle')}</h1>

        {/* Featured Reel with Image Facade */}
        <div className="mainReelWrapper">
          <VideoFacade
            src="https://www.youtube.com/embed/PT-vjO-g96g"
            title="Laura Candela Acting Reel"
          />
        </div>

        <h2 className="sectionTitle">{t('Scene')}</h2>

        {/* Scenes Grid */}
        <div className="videoGridContainer">
          {sceneClips.map((clip, index) => (
            <div key={index} className="videoGridItem">
              <VideoFacade src={clip.src} title={`Laura Candela - ${clip.title}`} />
            </div>
          ))}
        </div>

        {/* CV Download CTA */}
        <div className="cvCtaContainer">
          <a
            className="cvText"
            target="_blank"
            rel="noopener noreferrer"
            href={cvPdf}
            aria-label="Download Curriculum Vitae PDF"
          >
            CV
          </a>
        </div>
      </section>

      {/* Biography Section */}
      <section className="dataContainer brief" aria-label="Acting Background">
        <div className="dataContentWrapper">
          <img
            className="dataImage"
            src={writerImage}
            alt="Laura Candela Actress"
            loading="lazy"
          />
          <article className="briefP">
            <h2 className="dataTitle">{t('ActressTitle')}</h2>
            <p className="paragraf">{t('ActressText1')}</p>
            <p className="paragraf">{t('ActressText2')}</p>
            <p className="paragraf">{t('ActressText3')}</p>
          </article>
        </div>
      </section>
    </main>
  );
};

export default Actress;